import { useAdLibrary, type UseAdLibrary } from './hooks/useAdLibrary';
import { listPlayables, type Playable } from './playable-api';

/** The job kinds that write onto a mini-game: its AI art run (plate and sprite sheets, landing asset by asset).
 *  Module-level so the hook's options stay stable. */
const PLAYABLE_JOB_KINDS: readonly string[] = ['playable_assets'];

/** A brand's mini-games, kept fresh while an art run lands (see {@link useAdLibrary}). */
export const usePlayableLibrary = (tenantId?: number): UseAdLibrary<Playable> =>
  useAdLibrary<Playable>(tenantId, { list: listPlayables, doneKinds: PLAYABLE_JOB_KINDS });
